import React, { Component } from 'react';
import Layout from "../components/layout";
import {connect} from "react-redux";
import ActivityTrackerHOC from "../components/General/activityTracker";

class LayoutHOC extends Component{
    render(){
        return(
            <Layout
            history={this.props.history}
            toggleDrawer={this.props.toggleDrawer}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
    }
};

const mapDispatchToProps = (dispatch) => {
    return {

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivityTrackerHOC(LayoutHOC));


// WEBPACK FOOTER //
// ./src/containers/LayoutHOC.js